import styled, { css } from 'styled-components';

import { Loader as LoaderComponent } from '@/components/Loader';

export const Wrapper = styled.div<{
  $isProcessing: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;

  ${({ $isProcessing, theme }) => css`
    ${$isProcessing &&
    css`
      position: fixed;
      ::before {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        content: ' ';
        background: ${theme.colors.white};
        opacity: 0.5;
        pointer-events: all;
        z-index: ${theme.zIndex.alwaysVisible};
      }
    `}
  `}
`;

export const Loader = styled(LoaderComponent)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${({ theme }) =>
    css`
      z-index: ${theme.zIndex.alwaysVisible};
    `}
`;
